import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import PlayerRankings from "Components/Tournament/PlayerRankings";
import LocationImageUploader from "Components/Location/LocationImageUploader";
import LocationAddress from "./LocationAddress";

const FacebookIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="#1877F2">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const LeftSidebar = ({
  location,
  locationId,
  locationRankings,
  isAdmin,
  locationImage,
  onImageChange,
  addressPoint,
}) => {
  const [showFullImage, setShowFullImage] = useState(false);
  const hasImage = isAdmin || locationImage?.trim();
  const hasRankings = location?.usesRankings;

  if (!hasImage && !hasRankings && !addressPoint && !location?.facebook) return null;

  return (
    <div className="space-y-4">
      {isAdmin ? (
        <LocationImageUploader
          locationId={locationId}
          imageUrl={locationImage}
          onImageChange={onImageChange}
          onClickImage={() => setShowFullImage(true)}
        />
      ) : (
        locationImage?.trim() && (
          <img
            src={locationImage}
            alt=""
            className="w-full h-40 object-cover rounded-lg cursor-pointer"
            onClick={() => setShowFullImage(true)}
            onError={(e) => { e.target.style.display = "none"; }}
          />
        )
      )}
      {showFullImage && locationImage?.trim() && createPortal(
        <div
          className="fixed inset-0 z-[9999] bg-black/80 flex items-center justify-center p-4"
          onClick={() => setShowFullImage(false)}
        >
          <img
            src={locationImage}
            alt=""
            className="max-w-full max-h-full object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>,
        document.body
      )}
      {addressPoint && <LocationAddress point={addressPoint} className="px-1" />}
      {location?.facebook && (
        <a
          href={location.facebook}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-1 py-2 text-sm text-slate-300 hover:text-white transition"
        >
          <FacebookIcon className="h-6 w-6" />
          <span>Joignez-nous sur Facebook</span>
        </a>
      )}
      {hasRankings && location.displayRanking && (
        <div>
          <div className="flex items-center justify-between mb-3 px-1">
            <h3 className="uppercase text-sm text-slate-400 tracking-wider">
              Classement
            </h3>
            {isAdmin && (
              <Link
                to={`/locations/${locationId}/rankings`}
                className="px-2 py-1 text-xs bg-violet-600 hover:bg-violet-500 text-white rounded font-semibold transition"
              >
                Gérer
              </Link>
            )}
          </div>
          <PlayerRankings
            locationRankings={locationRankings}
            isAdmin={false}
          />
        </div>
      )}
    </div>
  );
};

export default LeftSidebar;
